export default "__VITE_ASSET__UPOS7N8I__"